import { createSlice } from '@reduxjs/toolkit'
import * as toolsStorage from '@/tools/storage'
import * as types from '@/types'
import { saveHistoryData } from './dashboard'

const getLang = () => {
  const lang = toolsStorage.getItem('i18nextLng');
  let newLang = lang || 'en-US';
  // let newLang = '';
  // if(!lang || lang === 'zh-CN') {
  //   newLang = 'zh-CN'
  // } else {
  //   newLang = lang.includes('zh-') ? 'zh-TW' : 'en-US';
  // }
  toolsStorage.setItem('i18nextLng', newLang)
  return newLang;
}

export const global = createSlice({
  name: 'globalData',
  initialState: {
    // theme: '',
    language: getLang(),
    isDev: process.env.SYS_ENV !== 'pro',
    currentDomain: `${window.location.protocol}//${window.location.host}`,
    userInfo: toolsStorage.getItem('userInfo'),
    deviceList: null, // 电池信息
    realTimeNotice: null, // 实时消息通知推送
    historyNewsList: null, // 消息通知列表

    // ota 更新
    otaInfo: null,
    otaUpdateResult: null,

    // vpp 状态
    vppRefreshStaus: null,

    isNight: false, // 是否是夜间模式

    upgradeFirmewareStatus: null, // 固件升级状态
  },
  reducers: {
    saveUserInfo: (state: types.PropNameAny, action) => {
      state.userInfo = {...action.payload}
    },
    saveDeviceList : (state: types.PropNameAny, action) => {
      state.deviceList = action.payload
    },
    saveLanguage:  (state: types.PropNameAny, action) => {
      state.language = action.payload
    },
   
    saveRealTimeNotice:  (state: types.PropNameAny, action) => {
      state.realTimeNotice = action.payload
    },
   
    saveHistoryNewsList: (state: types.PropNameAny, action) => {
      state.historyNewsList = action.payload
    },
    saveIsNight: (state: types.PropNameAny, action) => {
      state.isNight = action.payload
    },
    saveUpgradeFirmewareStatus: (state: types.PropNameAny, action) => {
      state.upgradeFirmewareStatus = action.payload
    }
  }
})

export const { 
  saveUserInfo,
  saveDeviceList,
  saveLanguage,
  saveRealTimeNotice,
  saveHistoryNewsList,
  saveIsNight,
  saveUpgradeFirmewareStatus
} = global.actions
export const getNeuronList = (state: any) => state.globalData.neuronList
export const getDeviceControlDefaultSettings = (state: any) => state.globalData.deviceControlDefaultSettings
export default global.reducer
